import classNames from "classnames";
import React, { FunctionComponent, useState } from "react";
import { useIntl } from "react-intl";
import HeaderAccount from "@Components/atoms/header/HeaderAccount";
import HeaderMobileCategories from "@Components/molecules/header/HeaderMobileCategories";
import useBannerKountriesHeight from "@Hooks/banner/useBannerKountriesHeight";
import { ReactComponent as IconAccount } from "@Icons/account.svg";
import { ReactComponent as IconBook } from "@Icons/book.svg";
import { ReactComponent as IconCart } from "@Icons/cart.svg";
import { ReactComponent as IconCross } from "@Icons/cross.svg";
import { ReactComponent as IconHome } from "@Icons/home.svg";
import { HeaderMenuLink } from "@Types/header";
import { Category } from "@Types/header";
import { cartLink } from "@Utils/links";
import "./style.scss";

interface Props {
  accountLinks: HeaderMenuLink[];
  cartArticlesLength: number;
  categories: Category[];
  featuredCategories?: Category[];
}

const HeaderMobileBottomTapBar: FunctionComponent<Props> = ({
  accountLinks,
  cartArticlesLength,
  categories,
  featuredCategories,
}) => {
  const intl = useIntl();
  const localeSlug = intl.locale;
  const [displayCategories, setDisplayCategories] = useState<boolean>(false);
  const [displayAccount, setDisplayAccount] = useState<boolean>(false);

  const bannerKountriesHeight = useBannerKountriesHeight();
  const headerHeight = 50;
  const tapBarHeight = 64;
  const headerMobileBottomTapBarStyle = {
    height: `calc(100vh - ${headerHeight + tapBarHeight + bannerKountriesHeight - 1}px )`,
    top: `${headerHeight + bannerKountriesHeight}px`,
  };

  const pathname = window.location.pathname.split("/")[2];
  const activeCart = pathname === cartLink.split("/")[1] && !displayCategories && !displayAccount;
  const activeHome =
    (pathname === "/" || pathname === "" || pathname === undefined) &&
    !displayCategories &&
    !displayAccount;

  const handleDisplayCategories = () => {
    displayCategories ? addBodyScrolling() : removeBodyScrolling();
    setDisplayAccount(false);
    setDisplayCategories(!displayCategories);
  };

  const handleDisplayAccount = () => {
    displayAccount ? addBodyScrolling() : removeBodyScrolling();
    setDisplayCategories(false);
    setDisplayAccount(!displayAccount);
  };

  const handleClose = () => {
    addBodyScrolling();
    setDisplayAccount(false);
    setDisplayCategories(false);
  };

  const removeBodyScrolling = () => {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
  };

  const addBodyScrolling = () => {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
  };

  return (
    <div className="HeaderMobileBottomTapBar">
      <a
        className={classNames("HeaderMobileBottomTapBar-item", {
          "HeaderMobileBottomTapBar-item--active": activeHome,
        })}
        href={`/${localeSlug}/`}
      >
        <IconHome />
        <div className="HeaderMobileBottomTapBar-text">
          {intl.formatMessage({ id: "cheerz_Header_home" })}
        </div>
      </a>
      <div
        className={classNames("HeaderMobileBottomTapBar-item", {
          "HeaderMobileBottomTapBar-item--active": displayCategories,
        })}
        onClick={handleDisplayCategories}
      >
        <IconBook />
        <div className="HeaderMobileBottomTapBar-text">
          {intl.formatMessage({ id: "cheerz_Header_category" })}
        </div>
      </div>
      <div
        className={classNames("HeaderMobileBottomTapBar-item", {
          "HeaderMobileBottomTapBar-item--active": displayAccount,
        })}
        onClick={handleDisplayAccount}
      >
        <IconAccount />
        <div className="HeaderMobileBottomTapBar-text">
          {intl.formatMessage({ id: "cheerz_Header_myAccount" })}
        </div>
      </div>
      <a
        className={classNames("HeaderMobileBottomTapBar-item", {
          "HeaderMobileBottomTapBar-item--active": activeCart,
        })}
        href={`/${localeSlug}${cartLink}`}
      >
        <IconCart />
        <div className="HeaderMobileBottomTapBar-cart-length">{cartArticlesLength}</div>
        <div className="HeaderMobileBottomTapBar-text">
          {intl.formatMessage({ id: "cheerz_Header_cart" })}
        </div>
      </a>
      <div
        className={classNames("HeaderMobileBottomTapBar-paneWrapper", {
          active: displayCategories,
        })}
        style={headerMobileBottomTapBarStyle}
      >
        <HeaderMobileCategories categories={categories} featuredCategories={featuredCategories} />
      </div>
      <div
        className={classNames("HeaderMobileBottomTapBar-paneWrapper", { active: displayAccount })}
        style={headerMobileBottomTapBarStyle}
      >
        <HeaderAccount accountLinks={accountLinks} />
      </div>
      {(displayCategories || displayAccount) && (
        <div
          className="HeaderMobileBottomTapBar-close"
          onClick={handleClose}
          style={{ top: bannerKountriesHeight }}
        >
          <IconCross />
        </div>
      )}
    </div>
  );
};

export default HeaderMobileBottomTapBar;
